export class StoryFlowMenuItemViewModel {
    id: number;
    title: string;
    icon: string;
    color: string;
    is_completed: boolean = false;
}